import { styled } from '@mui/material';

export const sxStyles = {
  headSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: '1240px',

    '& > a:first-of-type': {
      minWidth: '124px',
    },
  },
};

export const StyledAreaCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '2rem',
  margin: '2rem 0',

  [theme.breakpoints.up('xs')]: {
    justifyContent: 'start',
  },
}));
